import { useQuests } from "../api/hooks.ts";
import { copy } from "../copy/index.ts";
import styles from "./QuestCard.module.css";
import { Icon } from "./ui.tsx";

const t = copy.home.quests;

/** C15 – today's three quests and the chest (SPEC 7.7, T2.9b). Hidden while loading or offline. */
export function QuestCard() {
  const q = useQuests();
  if (!q.data?.quests.length) return null;
  const { quests, chestOpened } = q.data;
  const done = quests.filter((x) => x.done).length;
  return (
    <section className={styles.card} aria-labelledby="quests-title">
      <header className={styles.head}>
        <span className={chestOpened ? styles.chestOpen : styles.chest}>
          <Icon name={chestOpened ? "chest_open" : "chest"} size={44} />
        </span>
        <div>
          <h2 id="quests-title">{t.title}</h2>
          <p>{chestOpened ? t.allDone : t.sub}</p>
        </div>
        <strong className={styles.count}>{t.progress(done, quests.length)}</strong>
      </header>
      <ul className={styles.list}>
        {quests.map((x) => (
          <li
            key={x.key}
            className={x.done ? styles.done : undefined}
            aria-label={x.done ? t.doneLabel(x.title) : t.leftLabel(x.title, x.progress, x.target)}
          >
            <Icon name={x.icon} size={30} />
            <div className={styles.body}>
              <span className={styles.name}>{x.title}</span>
              <span className={styles.bar} aria-hidden="true">
                <span style={{ width: `${(100 * x.progress) / x.target}%` }} />
              </span>
            </div>
            {x.done ? (
              <Icon name="check" size={30} />
            ) : (
              <span className={styles.num} aria-hidden="true">
                {t.progress(x.progress, x.target)}
              </span>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
